import { useRef, type ChangeEvent } from "react";
import { sendDocument, sendMedia } from "../../../api/whatsapp.js";
import { fileKindFor } from "../../Chat.helpers.ts";
import { SvgIcon } from "../../chat-list/ChatAvatar.tsx";
import { icons } from "../icons.ts";

type AttachmentMenuProps = {
  chatJid: string;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onSent: () => void;
  onError: (message: string) => void;
  onSuccess: (message: string) => void;
};

export function AttachmentMenu({
  chatJid,
  open,
  onToggle,
  onClose,
  onSent,
  onError,
  onSuccess,
}: AttachmentMenuProps) {
  const mediaInputRef = useRef<HTMLInputElement | null>(null);
  const documentInputRef = useRef<HTMLInputElement | null>(null);

  async function sendFile(event: ChangeEvent<HTMLInputElement>, forceDocument = false) {
    const file = event.currentTarget.files?.[0];
    if (!file) return;
    const kind = forceDocument ? "document" : fileKindFor(file);
    try {
      onSuccess(`Enviando ${file.name || "arquivo"}...`);
      if (kind === "document") await sendDocument({ chatJid, file });
      else await sendMedia({ chatJid, kind, file });
      onSent();
    } catch (err) {
      onError(err instanceof Error ? err.message : "Falha ao enviar");
    } finally {
      event.currentTarget.value = "";
    }
  }

  return (
    <>
      <div className="wa-attach-anchor">
        <button
          className={`wa-icon-btn ${open ? "is-active" : ""}`}
          type="button"
          title="Anexar"
          aria-label="Anexar"
          onClick={onToggle}
        >
          <SvgIcon svg={icons.attach} />
        </button>
        {open ? (
          <div className="wa-attach-popover" role="menu" aria-label="Anexar">
            <button
              className="wa-attach-option"
              type="button"
              role="menuitem"
              onClick={() => {
                onClose();
                mediaInputRef.current?.click();
              }}
            >
              <span className="wa-attach-icon" style={{ background: "#bf59cf" }}><SvgIcon svg={icons.photo} /></span>
              <span>Foto ou video</span>
            </button>
            <button
              className="wa-attach-option"
              type="button"
              role="menuitem"
              onClick={() => {
                onClose();
                documentInputRef.current?.click();
              }}
            >
              <span className="wa-attach-icon" style={{ background: "#5157ae" }}><SvgIcon svg={icons.document} /></span>
              <span>Documento</span>
            </button>
          </div>
        ) : null}
      </div>
      <input
        ref={mediaInputRef}
        type="file"
        style={{ display: "none" }}
        accept="image/*,video/*"
        onChange={(event) => void sendFile(event, false)}
      />
      <input
        ref={documentInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(event) => void sendFile(event, true)}
      />
    </>
  );
}
